import { useState, useEffect } from 'react';

export const useAdvancedSettings = (eshop, eshopId) => {
    const [advancedSettings, setAdvancedSettings] = useState({
        pagination: {
            next_button: "a[rel='next']",
            page_param: "p",
            max_pages: 50,
        },
        testing: {
            product_limit: 0,
            enabled: false,
        },
        rate_limiting: {
            requests_per_minute: 30,
            delay_between_requests: 100
        },
        retry_settings: {
            max_retries: 3,
            retry_delay: 5000
        },
        enable_lazy_scroll: false,
        ajax_timeout: 10,
        ajax_interval: 50,
        page_load_timeout: 300,
        ajax_selectors: '.product-price-ajax,.product-availability-ajax',
        ajax_content_selectors: '.product-price,.product-price-wrapper,.e-pm-price',
        ajax_wait_for_detail_page: false
    });

    const [categories, setCategories] = useState([
        { name: '', products_url: '', category_default: '' }
    ]);

    // Load advanced settings when eshop data is available
    useEffect(() => {
        if (eshop && eshopId && eshop.config_json) {
            if (eshop.config_json.advanced) {
                setAdvancedSettings(eshop.config_json.advanced);
            }

            // Set categories if they exist in the saved config
            if (eshop.config_json.categories) {
                setCategories(eshop.config_json.categories);
            } else {
                // Initialize with empty category if none exist
                setCategories([{ name: '', products_url: '', category_default: '' }]);
            }
        }
    }, [eshop, eshopId]);

    return {
        advancedSettings,
        setAdvancedSettings,
        categories,
        setCategories
    };
};